// action - customization reducer
export const SET_MENU = 'SET_MENU';
export const MENU_TOGGLE = 'MENU_TOGGLE';
export const MENU_OPEN = 'MENU_OPEN';
export const SET_FONT_FAMILY = 'SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = 'SET_BORDER_RADIUS';